$(function() {

	$('[data-toggle="tooltip"]').tooltip({
		container:'body'
	});

});